<template>
  <main-template
    :header="header"
    :is-loading="isLoading"
  >
    <div class="container-fluid container">
      <div style="margin-bottom: 80px">
        <h1>OUR BRANDS</h1>
        <div v-html="content" />
      </div>

      <section
        class="hospitality-section"
        aria-label="hospitality"
      >
        <carousel
          title="HOSPITALITY"
          autoplay
          :items-per-page="itemPerPage"
        >
          <property-card-component
            v-for="(hospitality, index) of hospitalityList"
            :key="`hospitality-${index}`"
            :title="hospitality.title"
            :subtitle="hospitality.subtitle"
            :description="hospitality.description"
            :image-list="hospitality.imageList"
            :link="hospitality.link"
          />
        </carousel>
      </section>

      <section
        class="real-estate-section"
        aria-label="realEstate"
      >
        <carousel
          title="REAL ESTATE"
          autoplay
          :items-per-page="itemPerPage"
        >
          <property-card-component
            v-for="(realEstate, index) of realEstateList"
            :key="`real-estate-${index}`"
            :title="realEstate.title"
            :subtitle="realEstate.subtitle"
            :description="realEstate.description"
            :image-list="realEstate.imageList"
            :link="realEstate.link"
          />
        </carousel>
      </section>

      <section
        class="food-and-beverage-section"
        aria-label="Food and Beverage"
      >
        <carousel
          title="FOOD & BEVERAGE"
          autoplay
          :items-per-page="itemPerPage"
        >
          <property-card-component
            v-for="(foodAndBeverage, index) of foodAndBeverageList"
            :key="`food-and-beverage-${index}`"
            :title="foodAndBeverage.title"
            :subtitle="foodAndBeverage.subtitle"
            :description="foodAndBeverage.description"
            :image-list="foodAndBeverage.imageList"
            :link="foodAndBeverage.link"
          />
        </carousel>
      </section>
    </div>
  </main-template>
</template>

<script>
import _ from 'lodash'
import { COVER_IMG_TYPE, HERO_TEXT_CONFIG_KEY, SERVICE_KEY, OUR_BRANDS_CONST } from '@/configs/constants'
import ConfigApi from '@/api/config-api'
import AlertMixin from '@/mixins/alert-mixin'
import MainTemplate from '@/templates/MainTemplate'
import Carousel from '@/components/Carousel'
import PropertyCardComponent from './components/PropertyCardComponent'

export default {
  name: 'OurBrands',
  mixins: [AlertMixin],
  components: { PropertyCardComponent, Carousel, MainTemplate },
  data () {
    return {
      isLoading: false,
      content: '',
      header: {
        className: '',
        style: '',
        imgPath: '',
        isShow: true,
        resizeLogo: true,
        heroText: {
          headline: '',
          subHeadline: ''
        }
      },
      hospitalityList: OUR_BRANDS_CONST.HOSPITALITY_LIST,
      realEstateList: OUR_BRANDS_CONST.REAL_ESTATE_LIST,
      foodAndBeverageList: OUR_BRANDS_CONST.FOOD_AND_BEVERAGE_LIST
    }
  },
  computed: {
    itemPerPage () {
      const screenWidth = window.innerWidth

      return (screenWidth <= 768) ? 1 : 3
    }
  },
  async created () {
    this.isLoading = true

    try {
      const promiseList = [
        ConfigApi.coverImgUrl(COVER_IMG_TYPE.OUR_BRANDS),
        ConfigApi.configByKey(SERVICE_KEY.OUR_BRANDS),
        ConfigApi.configByKey(HERO_TEXT_CONFIG_KEY.OUR_BRANDS)
      ]

      const responseList = await Promise.all(promiseList)
      const coverImage = responseList[0]
      const heroTextValue = _.get(responseList, '[2].configValue', '{}')

      this.header.imgPath = coverImage.url
      this.content = _.get(responseList, '[1].configValue', '')
      this.header.heroText = JSON.parse(heroTextValue)
    } catch (error) {
      this.alertMessageError(error.message)
    } finally {
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
section {
  margin-bottom: 60px;
}

.real-estate-section {
  position: relative;
  padding-top: 40px;
}

.real-estate-section:after {
  content: '';
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  width: 100vw;
  height: 102%;
  background-color: #D9D9D926;
  pointer-events: none;
}
</style>
